import React from 'react';
import PropTypes from 'prop-types';
import './analyticsStatCard.scss';
import Typography from '../Typography';
import COLORS from '../../util/constants/colors';
import LoadingAnimation from '../../containers/Analytics/LoadingAnimation';

const AnalyticsStatCard = ({
  label,
  value,
  valueColor,
  unit,
  subtitle,
  icon,
  iconColor,
  loading,
}) => {
  return (
    <div className="analytics-stat-card">
      <div className="analytics-stat-card-content">
        <Typography variant="text" size="xsmall" bold color={COLORS.TEXT_TERTIARY_LITE}>
          {label}
        </Typography>
        {loading ? (
          <LoadingAnimation variant="random" size="xsmall" color={valueColor} />
        ) : (
          <div className="analytics-stat-card-value">
            <Typography variant="text" size="large" bold color={valueColor}>
              {value}
            </Typography>
            <Typography style={{ marginLeft: '4px' }} variant="text" size="xsmall" bold color={valueColor}>
              {unit}
            </Typography>
          </div>
        )}
        {!loading && subtitle && (
          <Typography variant="text" size="xsmall" color={COLORS.TEXT_TERTIARY_LITE}>
            {subtitle}
          </Typography>
        )}
      </div>
      <div
        className="analytics-stat-card-icon"
        style={{ backgroundColor: iconColor }}
      >
        {icon}
      </div>
    </div>
  );
};

AnalyticsStatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueColor: PropTypes.string.isRequired,
  unit: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.node.isRequired,
  iconColor: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

AnalyticsStatCard.defaultProps = {
  unit: '',
  subtitle: '',
  value: null,
  loading: false,
};

export default AnalyticsStatCard;
